export default {
  mapValue(mappingItem, row, fieldsMap) {
    const field = fieldsMap[mappingItem.to?.value];
    switch (field?.schema.type) {
      case 'user':
      case 'string':
      case 'number':
        return row[mappingItem.from.value];
    }
  },
};
